import ReactDOM from 'react-dom';
import { useEffect, useState } from 'react';
import NotifiationBanner from '~components/dumbs/NotificationBanner';
import usePortal from '~hooks/usePortal';
import useDoubleSwitchDelay from '~hooks/useDoubleSwitchDelay';

import * as styled from './Toast.styles';
import { Props } from './types';

const animationDuration = 1000;

function Toast({
  title,
  variant = 'default',
  isVisible,
  onDismiss,
  lifetime,
}: Props) {
  const portal = usePortal('root');
  const { left: toastVisibility, right: isScaffoldingVisible } =
    useDoubleSwitchDelay(isVisible, animationDuration);
  const [dismissTimeout, setDismissTimeout] = useState<NodeJS.Timeout | null>(
    null
  );

  function setupLifetime() {
    if (!lifetime) {
      return;
    }

    const timeoutId = setTimeout(() => {
      onDismiss();
    }, lifetime);

    setDismissTimeout(timeoutId);
  }

  function clearDismissTimeout() {
    if (dismissTimeout) {
      clearTimeout(dismissTimeout);
      setDismissTimeout(null);
    }
  }

  useEffect(() => {
    clearDismissTimeout();
    if (isVisible) {
      setupLifetime();
    }
  }, [isVisible]);

  if (!portal) return null;

  if (!isScaffoldingVisible) return null;

  return ReactDOM.createPortal(
    <styled.Wrapper
      show={toastVisibility}
      animationDuration={animationDuration}
    >
      <styled.MovingPart>
        <NotifiationBanner
          variant={variant}
          title={title}
          onDismiss={onDismiss}
        />
      </styled.MovingPart>
    </styled.Wrapper>,
    portal
  );
}

export default Toast;
